import { useEffect } from "react";
import { useTenant, useStartup } from "./hooks";
import { prefetchUrl } from "./hooks/useFetch";
import { AccountSettingsProvider, useAccountSettings } from "./contexts/AccountSettingsContext";
import App from "./App";

const AppWithSettings = () => {
  const { tenantId, companySelected, branchSelected } = useTenant();
  const { startup } = useStartup();
  const { fetchSettings } = useAccountSettings();

  useEffect(() => {
    if (!startup) return;
    if (!tenantId || !companySelected?.value || !branchSelected?.value) return;
    
    const taxesUrl = `${process.env.REACT_APP_VAT_WEB_BASE_URL}/sales/taxes/${tenantId}/${companySelected.value}/${branchSelected.value}`;
    prefetchUrl(taxesUrl);
    
    // Fetch account settings
    fetchSettings(tenantId, companySelected.value);
  }, [startup, tenantId, companySelected?.value, branchSelected?.value, fetchSettings]);

  return <App />;
};

export default AppWithSettings;
